import React, { createContext, useContext, useState } from 'react'
import { useDispatch } from 'react-redux'
import api from '../../../api/pntalert.api'
import { actions } from '../../../actions/snack.actions'
import { useIsMerchant } from '../../../config/utils/RolesUtils'
import { useTranslation } from 'react-i18next'
import { actions as loaderActions } from '@/actions/loader.actions'

const initialContext = {
  load() {},
  loadPending() {},
  countPending() {},
  check() {},
  alerts: [],
  pendingAlerts: [],
  totalPending: 0,
}

export const PntAlertContext = createContext(initialContext)

export function usePntAlertContext() {
  return useContext(PntAlertContext)
}

const PntAlertProvider = ({ children }) => {
  const { t } = useTranslation()
  const isMerchant = useIsMerchant()

  const dispatch = useDispatch()

  const [alerts, setAlerts] = useState([])
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(1)

  const [pendingAlerts, setPendingAlerts] = useState([])
  const [totalPending, setTotalPending] = useState(0)

  async function load(params) {
    return dispatch(
      loaderActions.withGlobalLoader(() =>
        api.loadAlerts(params).then((response) => {
          setAlerts(response.data?.resultList ?? [])
          setCount(response.data?.totalResult ?? 0)
          setPage(response.data?.page ?? 0)
          return response
        }),
      ),
    )
  }

  const loadPending = async () => {
    let params
    if (isMerchant) {
      params = {
        size: 10,
        querysearch: ['reviewmerch:eq(0)'],
      }
    }

    dispatch(
      loaderActions.withGlobalLoader(() =>
        api.loadAlerts(params).then((response) => {
          setPendingAlerts(response.data?.resultList ?? [])
          setTotalPending(response.data?.totalResult ?? 0)
        }),
      ),
    )
  }

  const countPending = async () => {
    let params
    if (isMerchant) {
      params = {
        size: 10,
        querysearch: ['reviewmerch:eq(0)'],
      }
    }

    dispatch(
      loaderActions.withGlobalLoader(() =>
        api.countAlerts(params).then((response) => {
          setTotalPending(response.data ?? 0)
        }),
      ),
    )
  }

  const check = async (alerts) => {
    return dispatch(
      loaderActions.withGlobalLoader(() =>
        api.checkAlert(alerts).then(() => {
          dispatch(actions.notify(t('ALERT.CLEAR'), 'success'))
          loadPending()
        }),
      ),
    )
  }

  return (
    <PntAlertContext.Provider
      value={{
        load,
        loadPending,
        countPending,
        check,
        alerts,
        count,
        page,
        pendingAlerts,
        totalPending,
      }}>
      {children}
    </PntAlertContext.Provider>
  )
}

export default PntAlertProvider
